const LEGACY_API_URL = 'https://8zgroi30f1.execute-api.us-east-1.amazonaws.com/dev';
const DEV_SITE_URL = 'http://localhost:3000';
const PROD_SITE_URL = 'https://jorvex.degenden.xyz';

const env = (key) => {
  if (typeof process === 'undefined' || !process?.env) return '';
  return String(process.env[key] || '').trim();
};

const normalizeMode = (value) => {
  const mode = String(value || '').trim().toLowerCase();
  if (['prod', 'production', 'live'].includes(mode)) return 'production';
  if (['dev', 'development', 'local'].includes(mode)) return 'development';
  return 'development';
};

const parseFlag = (value, fallback) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) return fallback;
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return fallback;
};

const rawAppEnv =
  env('REACT_APP_APP_ENV') ||
  env('REACT_APP_MODE') ||
  env('APP_ENV');

export const APP_ENV = normalizeMode(rawAppEnv);
export const IS_PROD = APP_ENV === 'production';
export const IS_DEV = !IS_PROD;

export const API_BASE_URL = (
  env('REACT_APP_API_URL') ||
  env(IS_PROD ? 'REACT_APP_PROD_API_URL' : 'REACT_APP_DEV_API_URL') ||
  LEGACY_API_URL
).replace(/\/+$/, '');

export const SITE_URL = (
  env('REACT_APP_SITE_URL') ||
  env('PUBLIC_SITE_URL') ||
  (IS_PROD ? PROD_SITE_URL : DEV_SITE_URL)
).replace(/\/+$/, '');

if (typeof console !== 'undefined' && IS_PROD && !env('REACT_APP_API_URL')) {
  console.warn(
    'Jorvex runtime warning: REACT_APP_API_URL is not set. Falling back to the legacy API URL.'
  );
}

export const apiUrl = (path = '') => `${API_BASE_URL}${path}`;

export const FEATURE_FLAGS = {
  demos: parseFlag(env('REACT_APP_ENABLE_DEMOS'), !IS_PROD),
  localAgents: parseFlag(env('REACT_APP_ENABLE_LOCAL_AGENTS'), !IS_PROD),
  rightPanelBetaNotice: parseFlag(env('REACT_APP_SHOW_RIGHT_PANEL_BETA'), IS_DEV),
};
